<mat-form-field class="ui-chip-field ui-form-field-v2" appearance="outline" subscriptSizing="fixed">
  @if (label) {
    <mat-label>{{ label }}</mat-label>
  }
  <mat-chip-grid #chipList attr.aria-label="{{ label }}" [disabled]="disabled">
    @for (item of selectedItems; track item) {
      <mat-chip-row [value]="item" (removed)="remove(item)">
        <span class="chip-text">{{ item }}</span>
        <button matChipRemove>
          <mat-icon class="ui-form-field__icon">cancel</mat-icon>
        </button>
      </mat-chip-row>
    }
    <input
      [placeholder]="selectedItems.length ? '' : ('newItemPlaceholder' | translate)"
      #inputField
      [formControl]="inputControl"
      [matAutocomplete]="auto"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      (matChipInputTokenEnd)="addKeywordFromInput($event)"
    />
  </mat-chip-grid>
  <mat-autocomplete
    #auto="matAutocomplete"
    class="app-ui-select"
    (optionSelected)="selected($event)"
  >
    @for (item of filteredItems | async; track item.name) {
      <mat-option [value]="item.name">
        {{ item.name }}
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
